<template>
  <div class="search-cont authentic">
    <div class="zhezhao"></div>
    <div class="center">
      <div class="cont-right">
        <span class="close">
          <img src="../../assets/img/close.png" alt />
        </span>
        <div class="logo">认证中心</div>
        <ul class="auth-classify">
          <li @click="media(1)">
            <img src="../../assets/img/personal.png" alt />
            <p class="name">个人</p>
            <p class="intro">适合垂直领域专家、意见领袖、评论家及自媒体人士申请。</p>
            <div class="choice">选择</div>
          </li>
          <li @click="media(2)">
            <img src="../../assets/img/media.png" alt />
            <p class="name">媒体机构</p>
            <p class="intro">适合报纸，杂志，电视，电台，通讯社或其它以生产内容为主的组织机构。</p>
            <div class="choice">选择</div>
          </li>
          <li @click="media(3)">
            <img src="../../assets/img/contry.png" alt />
            <p class="name">国家机构</p>
            <p class="intro">国内各级各类政府机构，事业单位，具有行政职能的社会组织等。</p>
            <div class="choice">选择</div>
          </li>
          <li @click="media(4)">
            <img src="../../assets/img/org.png" alt />
            <p class="name">企业机构</p>
            <p class="intro">适合企业，公司，分支机构，企业相关品牌，产品与服务等。</p>
            <div class="choice">选择</div>
          </li>
          <li @click="media(5)">
            <img src="../../assets/img/others.png" alt />
            <p class="name">其他组织</p>
            <p class="intro">适合各类公共场馆，公益机构，学校，社团，民间组织等机构团体。</p>
            <div class="choice">选择</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      content: [],
      n: 0,
      keyWord: ""
    };
  },
  mounted() {
    const self = this;
    // 关闭页面
    $(".close").click(function() {
      self.$parent.$data.panelModal = false;
    });
  },
  methods: {
    common() {
      this.$parent.$data.panelModal = false;
      this.$store.commit("userPerson", { a: true });
    },
    personal() {
      this.$parent.name = "person";
    },
    media(type) {
      this.$parent.name = "mediaOrg";
      this.$store.commit("mediaStatus", { type: type });
    }
  }
};
</script>
<style scoped>
.search-cont .center{width:1050px;margin-left:-525px;}
.search-cont .center .cont-right .close {
  width: 20px;
  height: 20px;
  margin-right:30px;
}
</style>